import Http from "../services/Providers/Http";

const ENDPOINTS = {
  LOGIN: "/api/auth/login"
};

export default {
  login: (body, payload, params) => {
    return Http.post(ENDPOINTS.LOGIN, body, params, null, payload);
  }
};
